<template>
  <div>
    <el-dialog
      title="Ətraflı məlumat"
      :visible.sync="showModal"
      width="80%"
      top="5vh"
      append-to-body
      :close-on-press-escape="false"
       :close-on-click-modal="false" 
    >
      <div>
        <accident-base :value="item" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showModal = false">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AccidentBase from "../components/AccidentBase.vue";
export default {
  data() {
    return {
      showModal: false,
      item: {},
    };
  },
  components: {
    AccidentBase,
  },
  methods: {
    view(item) {
      this.item = item;
      this.showModal = true;
    },
  },
};
</script>

<style scoped>
</style>
